/**
 * Mock data for student internships in the SCAD system
 * Centralized data source to be used across all components
 */

export const suggestedInternships = [
  {
    id: 'INT-2025-001',
    title: 'Frontend Developer Intern',
    company: 'Tech Solutions Inc.',
    companyLogo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    location: 'Cairo, Egypt',
    duration: '3 months',
    deadline: '2025-05-15',
    matchPercentage: 95,
    description: 'Join our engineering team to develop cutting-edge web applications using modern frontend technologies. You will work on real projects under the guidance of experienced mentors.',
    requirements: 'Knowledge of HTML, CSS, and JavaScript. Experience with React is a plus. Strong problem-solving skills and attention to detail.',
    responsibilities: 'Develop and maintain web applications, implement responsive designs, collaborate with the development team, participate in code reviews.',
    paid: true,
    salary: '5000-7000 EGP/month'
  },
  {
    id: 'INT-2025-002',
    title: 'Data Analyst Intern',
    company: 'Data Insights Co.',
    companyLogo: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    location: 'Alexandria, Egypt',
    duration: '6 months',
    deadline: '2025-05-20',
    matchPercentage: 88,
    description: 'Work with our data science team to analyze business data and develop insights. This internship offers hands-on experience with real-world datasets and analytics tools.',
    requirements: 'Statistics or Computer Science background, knowledge of Python, experience with data analysis libraries (Pandas, NumPy).',
    responsibilities: 'Clean and preprocess data, develop and implement statistical models, create visualizations, collaborate with the analytics team.',
    paid: true,
    salary: '6000-8000 EGP/month'
  },
  {
    id: 'INT-2025-003',
    title: 'Mobile App Developer Intern',
    company: 'App Innovators',
    companyLogo: 'https://images.unsplash.com/photo-1572044162444-ad60f128bdea?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    location: 'Cairo, Egypt',
    duration: '3 months',
    deadline: '2025-05-25',
    matchPercentage: 82,
    description: 'Join our mobile development team to create innovative applications for iOS and Android platforms. You will learn the latest mobile development technologies and best practices.',
    requirements: 'Basic knowledge of mobile development, familiarity with either Swift, Kotlin, or React Native.',
    responsibilities: 'Develop mobile applications, implement UI designs, test and debug applications, collaborate with the design and backend teams.',
    paid: true,
    salary: '5500-7500 EGP/month'
  }
];

export const applicationStatus = [
  {
    id: 'APP-2025-001',
    company: 'Global Marketing',
    position: 'Digital Marketing Intern',
    status: 'Pending',
    appliedDate: '2025-04-10',
    companyLogo: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
  },
  {
    id: 'APP-2025-002',
    company: 'Software Solutions',
    position: 'Backend Developer Intern',
    status: 'Interview',
    appliedDate: '2025-04-05',
    interviewDate: '2025-04-20',
    companyLogo: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
  },
  {
    id: 'APP-2025-005',
    company: 'ByteTech Systems',
    position: 'Frontend Developer Intern',
    status: 'Finalized',
    appliedDate: '2025-04-08',
    interviewDate: '2025-04-18',
    companyLogo: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
  },
  {
    id: 'APP-2025-003',
    company: 'Design Studio',
    position: 'UI/UX Design Intern',
    status: 'Rejected',
    appliedDate: '2025-03-25',
    companyLogo: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
  },
  {
    id: 'APP-2025-004',
    company: 'TechInnovate',
    position: 'Data Science Intern',
    status: 'Accepted',
    appliedDate: '2025-04-02',
    interviewDate: '2025-04-15',
    acceptedDate: '2025-04-25',
    startDate: '2025-06-01',
    companyLogo: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
  }
];

export const upcomingDeadlines = [
  {
    id: 'INT-2025-004',
    title: 'Web Developer Intern',
    company: 'Tech Innovate',
    deadline: '2025-05-12',
    daysLeft: 4
  },
  {
    id: 'INT-2025-005',
    title: 'Marketing Assistant',
    company: 'Brand Masters',
    deadline: '2025-05-15',
    daysLeft: 7
  },
  {
    id: 'INT-2025-006',
    title: 'Data Science Intern',
    company: 'Analytics Pro',
    deadline: '2025-05-18',
    daysLeft: 10
  }
];

export const workshops = [
  {
    id: 'WS-2025-003',
    title: 'AI in Architectural Design',
    category: 'Architecture',
    status: {
      label: 'Pre-recorded',
      badge: 'pre-recorded',
      actionButton: {
        label: 'Watch Now',
        action: 'watch'
      }
    },
    detailsButton: {
      label: 'View Details',
      action: 'viewDetails',
      modalContent: {
        title: true,
        instructor: true,
        category: true,
        price: true,
        description: true,
        datetime: true,
        duration: true
      }
    },
    description: 'Explore how artificial intelligence is revolutionizing architectural design. Learn to use AI tools for generative design, space optimization, and sustainable architecture.',
    date: '2025-05-11',
    time: '15:00 - 17:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Zoom',
    type: 'recorded',
    price: 75,
    thumbnailUrl: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 50,
    currentAttendees: 50,
    presenter: 'Prof. Elena Rodriguez',
    presenterImage: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Award-winning architect pioneering AI integration in architectural design, Professor at MIT.',
    prerequisites: ['Basic architectural design knowledge', 'Familiarity with CAD software'],
    materials: ['AI Design Tools Guide', 'Case Studies', 'Practice Datasets'],
    recording: true,
    videoUrl: '/assets/videos/ai-architecture.mp4',
    chapters: [
      { time: '0:00', title: 'Introduction to AI in Architecture' },
      { time: '25:30', title: 'Generative Design Principles' },
      { time: '55:45', title: 'Sustainable Design Optimization' },
      { time: '85:00', title: 'Case Studies and Applications' }
    ],
    rating: 4.7,
    reviews: [
      { name: 'Youssef Ali', rating: 5, comment: 'Revolutionary concepts and practical applications.' },
      { name: 'Maya Hassan', rating: 4.5, comment: 'Opened my eyes to new possibilities in architecture.' }
    ]
  },
  {
    id: 'WS-2025-004',
    title: 'Advanced React Development',
    category: 'Computer Science',
    status: {
      label: 'Live Now',
      badge: 'live',
      actionButton: {
        label: 'Join Now',
        action: 'join'
      }
    },
    detailsButton: {
      label: 'View Details',
      action: 'viewDetails',
      modalContent: {
        title: true,
        instructor: true,
        category: true,
        price: true,
        description: true,
        datetime: true,
        duration: true
      }
    },
    description: 'Master advanced React patterns, performance optimization, state management, and modern React features. Build scalable and maintainable React applications.',
    date: '2025-05-11',
    time: '13:00 - 15:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Zoom',
    type: 'live',
    price: 0,
    thumbnailUrl: 'https://images.unsplash.com/photo-1555099962-4199c345e5dd?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 45,
    currentAttendees: 38,
    presenter: 'David Cooper',
    presenterImage: 'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Senior React Developer at Facebook, Open Source Contributor to React Core.',
    prerequisites: ['Intermediate React knowledge', 'JavaScript proficiency'],
    materials: ['Code Examples', 'Performance Testing Tools', 'Best Practices Guide'],
    recording: true,
    chatEnabled: true,
    meetingLink: 'https://zoom.us/j/987654321',
    rating: 4.9,
    reviews: [
      { name: 'Kareem Saleh', rating: 5, comment: 'Best React workshop I\'ve attended!' },
      { name: 'Dina Mahmoud', rating: 4.8, comment: 'Excellent deep dive into React internals.' }
    ]
  },
  {
    id: 'WS-2025-005',
    title: 'Brand Strategy Masterclass',
    category: 'Marketing',
    status: {
      label: 'Upcoming',
      badge: 'upcoming',
      actionButton: {
        label: 'Register',
        action: 'register'
      }
    },
    detailsButton: {
      label: 'View Details',
      action: 'viewDetails',
      modalContent: {
        title: true,
        instructor: true,
        category: true,
        price: true,
        description: true,
        datetime: true,
        duration: true
      }
    },
    description: 'Develop comprehensive brand strategies that resonate with your target audience. Learn brand positioning, identity development, and communication strategies.',
    date: '2025-05-14',
    time: '11:00 - 13:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Microsoft Teams',
    type: 'upcoming',
    price: 25,
    thumbnailUrl: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 35,
    currentAttendees: 20,
    presenter: 'Emily Chen',
    presenterImage: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Brand Strategist with experience working with Fortune 500 companies.',
    prerequisites: ['Basic marketing knowledge'],
    materials: ['Brand Strategy Toolkit', 'Case Studies', 'Templates'],
    recording: true,
    rating: 0,
    reviews: []
  },
  {
    id: 'WS-2025-006',
    title: 'Financial Risk Management',
    category: 'Finance',
    status: {
      label: 'Upcoming',
      badge: 'upcoming',
      actionButton: {
        label: 'Register',
        action: 'register'
      }
    },
    detailsButton: {
      label: 'View Details',
      action: 'viewDetails',
      modalContent: {
        title: true,
        instructor: true,
        category: true,
        price: true,
        description: true,
        datetime: true,
        duration: true
      }
    },
    description: 'Learn modern risk management techniques, derivatives pricing, and portfolio protection strategies. Understand market, credit, and operational risks.',
    date: '2025-05-13',
    time: '15:00 - 17:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Zoom',
    type: 'upcoming',
    price: 45,
    thumbnailUrl: 'https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 40,
    currentAttendees: 15,
    presenter: 'Dr. James Wilson',
    presenterImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Risk Management Expert with 20 years experience in global financial institutions.',
    prerequisites: ['Understanding of financial markets', 'Basic statistics'],
    materials: ['Risk Models', 'Analysis Tools', 'Case Studies'],
    recording: true,
    rating: 0,
    reviews: []
  },
  {
    id: 'WS-2025-007',
    title: 'Sustainable Urban Design',
    category: 'Architecture',
    status: {
      label: 'Pre-recorded',
      badge: 'pre-recorded',
      actionButton: {
        label: 'Watch Now',
        action: 'watch'
      }
    },
    detailsButton: {
      label: 'View Details',
      action: 'viewDetails',
      modalContent: {
        title: true,
        instructor: true,
        category: true,
        price: true,
        description: true,
        datetime: true,
        duration: true
      }
    },
    description: 'Explore principles of sustainable urban design and development. Learn about green building practices, urban ecology, and community-focused design.',
    date: '2025-05-10',
    time: '14:00 - 16:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Zoom',
    type: 'recorded',
    price: 60,
    thumbnailUrl: 'https://images.unsplash.com/photo-1486744328743-c1066aa82780?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 100,
    currentAttendees: 100,
    presenter: 'Arch. Thomas Wright',
    presenterImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Sustainable Design Expert, LEED Certified Architect with global project experience.',
    prerequisites: ['Basic architectural knowledge'],
    materials: ['Sustainable Design Guidelines', 'Case Studies', 'Green Building Standards'],
    recording: true,
    videoUrl: '/assets/videos/sustainable-urban-design.mp4',
    chapters: [
      { time: '0:00', title: 'Introduction to Sustainable Design' },
      { time: '30:00', title: 'Green Building Practices' },
      { time: '60:00', title: 'Urban Ecology Integration' },
      { time: '90:00', title: 'Community Design Principles' }
    ],
    rating: 4.6,
    reviews: [
      { name: 'Hassan Ahmed', rating: 5, comment: 'Comprehensive coverage of sustainability.' },
      { name: 'Noura Selim', rating: 4.2, comment: 'Great practical examples and case studies.' }
    ]
  },
  {
    id: 'WS-2025-008',
    title: 'Machine Learning in Production',
    category: 'Computer Science',
    status: {
      label: 'Live Now',
      badge: 'live',
      actionButton: {
        label: 'Join Now',
        action: 'join'
      }
    },
    detailsButton: {
      label: 'View Details',
      action: 'viewDetails',
      modalContent: {
        title: true,
        instructor: true,
        category: true,
        price: true,
        description: true,
        datetime: true,
        duration: true
      }
    },
    description: 'Learn to deploy and maintain machine learning models in production environments. Cover MLOps, monitoring, and scaling ML applications.',
    date: '2025-05-11',
    time: '16:00 - 18:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Microsoft Teams',
    type: 'live',
    price: 0,
    thumbnailUrl: 'https://images.unsplash.com/photo-1509228627152-72ae9ae6848d?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 35,
    currentAttendees: 32,
    presenter: 'Dr. Sarah Lee',
    presenterImage: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'ML Engineer at Google, PhD in Machine Learning, specializing in MLOps.',
    prerequisites: ['Python programming', 'Basic ML knowledge'],
    materials: ['MLOps Toolkit', 'Monitoring Templates', 'Best Practices Guide'],
    recording: true,
    chatEnabled: true,
    meetingLink: 'https://teams.microsoft.com/l/meetup-join/xyz789',
    rating: 4.8,
    reviews: [
      { name: 'Ali Hassan', rating: 5, comment: 'Practical and immediately applicable.' },
      { name: 'Sara Mahmoud', rating: 4.6, comment: 'Great insights into production ML.' }
    ]
  },
  {
    id: 'WS-2025-009',
    title: 'Content Marketing Strategy',
    category: 'Marketing',
    status: {
      label: 'Upcoming',
      badge: 'upcoming',
      actionButton: {
        label: 'Register',
        action: 'register'
      }
    },
    detailsButton: {
      label: 'View Details',
      action: 'viewDetails',
      modalContent: {
        title: true,
        instructor: true,
        category: true,
        price: true,
        description: true,
        datetime: true,
        duration: true
      }
    },
    description: 'Develop effective content marketing strategies that drive engagement and conversions. Learn content planning, creation, and distribution.',
    date: '2025-05-12',
    time: '11:00 - 13:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Zoom',
    type: 'upcoming',
    price: 30,
    thumbnailUrl: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 45,
    currentAttendees: 25,
    presenter: 'Lisa Anderson',
    presenterImage: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Content Strategy Director at a leading digital agency.',
    prerequisites: ['Basic marketing knowledge'],
    materials: ['Content Strategy Template', 'Editorial Calendar', 'Style Guide'],
    recording: true,
    rating: 0,
    reviews: []
  },
  {
    id: 'WS-2025-010',
    title: 'Blockchain in Finance',
    category: 'Finance',
    status: {
      label: 'Pre-recorded',
      badge: 'pre-recorded',
      actionButton: {
        label: 'Watch Now',
        action: 'watch'
      }
    },
    detailsButton: {
      label: 'View Details',
      action: 'viewDetails',
      modalContent: {
        title: true,
        instructor: true,
        category: true,
        price: true,
        description: true,
        datetime: true,
        duration: true
      }
    },
    description: 'Explore blockchain technology applications in financial services. Learn about cryptocurrencies, smart contracts, and DeFi.',
    date: '2025-05-09',
    time: '14:00 - 16:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Zoom',
    type: 'recorded',
    price: 40,
    thumbnailUrl: 'https://images.unsplash.com/photo-1639152201720-5e536d254d81?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 60,
    currentAttendees: 60,
    presenter: 'Alex Martinez',
    presenterImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Blockchain Developer and Financial Technology Consultant.',
    prerequisites: ['Basic understanding of finance', 'Programming concepts'],
    materials: ['Blockchain Basics Guide', 'DeFi Case Studies', 'Smart Contract Examples'],
    recording: true,
    videoUrl: '/assets/videos/blockchain-finance.mp4',
    chapters: [
      { time: '0:00', title: 'Introduction to Blockchain' },
      { time: '30:00', title: 'Cryptocurrencies and Trading' },
      { time: '60:00', title: 'Smart Contracts in Finance' },
      { time: '90:00', title: 'DeFi Applications' }
    ],
    rating: 4.7,
    reviews: [
      { name: 'Mohamed Samy', rating: 4.8, comment: 'Eye-opening insights into DeFi.' },
      { name: 'Rania Hassan', rating: 4.6, comment: 'Clear explanations of complex concepts.' }
    ]
  },
  {
    id: 'WS-2025-011',
    title: 'Parametric Architecture',
    category: 'Architecture',
    status: {
      label: 'Upcoming',
      badge: 'upcoming',
      actionButton: {
        label: 'Register',
        action: 'register'
      }
    },
    detailsButton: {
      label: 'View Details',
      action: 'viewDetails',
      modalContent: {
        title: true,
        instructor: true,
        category: true,
        price: true,
        description: true,
        datetime: true,
        duration: true
      }
    },
    description: 'Master parametric design tools and techniques for creating innovative architectural solutions.',
    date: '2025-05-15',
    time: '15:00 - 17:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Microsoft Teams',
    type: 'upcoming',
    price: 55,
    thumbnailUrl: 'https://images.unsplash.com/photo-1487017159836-4e23ece2e4cf?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 30,
    currentAttendees: 12,
    presenter: 'Prof. Carlos Silva',
    presenterImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Leading expert in parametric design and computational architecture.',
    prerequisites: ['3D modeling experience', 'Basic programming concepts'],
    materials: ['Parametric Design Tools', 'Case Studies', 'Exercise Files'],
    recording: true,
    rating: 0,
    reviews: []
  },
  {
    id: 'WS-2025-012',
    title: 'Cloud Native Development',
    category: 'Computer Science',
    status: {
      label: 'Pre-recorded',
      badge: 'pre-recorded',
      actionButton: {
        label: 'Watch Now',
        action: 'watch'
      }
    },
    detailsButton: {
      label: 'View Details',
      action: 'viewDetails',
      modalContent: {
        title: true,
        instructor: true,
        category: true,
        price: true,
        description: true,
        datetime: true,
        duration: true
      }
    },
    description: 'Learn to build scalable, resilient applications using cloud-native technologies and microservices architecture.',
    date: '2025-05-10',
    time: '13:00 - 15:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Zoom',
    type: 'recorded',
    price: 0,
    thumbnailUrl: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 50,
    currentAttendees: 50,
    presenter: 'John Bennett',
    presenterImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Cloud Architect at AWS, specializing in distributed systems.',
    prerequisites: ['Basic cloud computing knowledge', 'Container basics'],
    materials: ['Architecture Diagrams', 'Code Examples', 'Best Practices Guide'],
    recording: true,
    videoUrl: '/assets/videos/cloud-native.mp4',
    chapters: [
      { time: '0:00', title: 'Cloud Native Principles' },
      { time: '30:00', title: 'Microservices Architecture' },
      { time: '60:00', title: 'Containers and Orchestration' },
      { time: '90:00', title: 'DevOps Integration' }
    ],
    rating: 4.9,
    reviews: [
      { name: 'Ahmed Nasser', rating: 5, comment: 'Comprehensive cloud-native coverage.' },
      { name: 'Mona Saleh', rating: 4.8, comment: 'Excellent practical examples.' }
    ]
  },
  {
    id: 'WS-2025-013',
    title: 'Advanced Algorithms and Data Structures',
    category: 'Computer Science',
    status: {
      label: 'Upcoming',
      badge: 'upcoming',
      actionButton: {
        label: 'Register',
        action: 'register'
      }
    },
    detailsButton: {
      label: 'View Details',
      action: 'viewDetails',
      modalContent: {
        title: true,
        instructor: true,
        category: true,
        price: true,
        description: true,
        datetime: true,
        duration: true
      }
    },
    description: 'Deep dive into advanced algorithms, complex data structures, and problem-solving techniques. Master competitive programming and technical interviews.',
    date: '2025-05-18',
    time: '14:00 - 16:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Zoom',
    type: 'upcoming',
    price: 50,
    thumbnailUrl: 'https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 40,
    currentAttendees: 15,
    presenter: 'Dr. Michael Chang',
    presenterImage: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Former Google engineer, ACM ICPC World Finalist, Algorithm Specialist',
    prerequisites: ['Data Structures fundamentals', 'Programming in C++ or Java'],
    materials: ['Algorithm Templates', 'Practice Problems', 'Interview Preparation Guide'],
    recording: true,
    rating: 0,
    reviews: []
  },
  {
    id: 'WS-2025-014',
    title: 'Sports Performance Analytics',
    category: 'Sports',
    status: {
      label: 'Upcoming',
      badge: 'upcoming',
      actionButton: {
        label: 'Register',
        action: 'register'
      }
    },
    detailsButton: {
      label: 'View Details',
      action: 'viewDetails',
      modalContent: {
        title: true,
        instructor: true,
        category: true,
        price: true,
        description: true,
        datetime: true,
        duration: true
      }
    },
    description: 'Learn to analyze sports performance data using advanced analytics tools. Cover player statistics, team dynamics, and predictive modeling in sports.',
    date: '2025-05-20',
    time: '16:00 - 18:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Microsoft Teams',
    type: 'upcoming',
    price: 45,
    thumbnailUrl: 'https://images.unsplash.com/photo-1587280501635-68a0e82cd5ff?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 35,
    currentAttendees: 20,
    presenter: 'Jake Thompson',
    presenterImage: 'https://images.unsplash.com/photo-1566492031773-4f4e44671857?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Sports Analytics Consultant for NBA teams, Former Professional Athlete',
    prerequisites: ['Basic statistics knowledge', 'Excel proficiency'],
    materials: ['Analytics Tools Guide', 'Performance Metrics Templates', 'Case Studies'],
    recording: true,
    rating: 0,
    reviews: []
  },
  {
    id: 'WS-2025-015',
    title: 'Digital Marketing Innovation',
    category: 'Marketing',
    status: {
      label: 'Upcoming',
      badge: 'upcoming',
      actionButton: {
        label: 'Register',
        action: 'register'
      }
    },
    detailsButton: {
      label: 'View Details',
      action: 'viewDetails',
      modalContent: {
        title: true,
        instructor: true,
        category: true,
        price: true,
        description: true,
        datetime: true,
        duration: true
      }
    },
    description: 'Explore cutting-edge digital marketing strategies, emerging platforms, and innovative campaign approaches. Master growth hacking and viral marketing techniques.',
    date: '2025-05-22',
    time: '13:00 - 15:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Zoom',
    type: 'upcoming',
    price: 35,
    thumbnailUrl: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 50,
    currentAttendees: 30,
    presenter: 'Sophie Martinez',
    presenterImage: 'https://images.unsplash.com/photo-1548142813-c348350df52b?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Digital Marketing Director at a Global Tech Company, Growth Marketing Expert',
    prerequisites: ['Basic marketing knowledge', 'Social media familiarity'],
    materials: ['Digital Marketing Playbook', 'Growth Hacking Tools', 'Campaign Templates'],
    recording: true,
    rating: 0,
    reviews: []
  },
  {
    id: 'WS-2025-016',
    title: 'Advanced AI and Deep Learning',
    category: 'AI',
    status: {
      label: 'Upcoming',
      badge: 'upcoming',
      actionButton: {
        label: 'Register',
        action: 'register'
      }
    },
    detailsButton: {
      label: 'View Details',
      action: 'viewDetails',
      modalContent: {
        title: true,
        instructor: true,
        category: true,
        price: true,
        description: true,
        datetime: true,
        duration: true
      }
    },
    description: 'Master advanced AI concepts, deep learning architectures, and neural network optimization. Build and deploy sophisticated AI models.',
    date: '2025-05-25',
    time: '15:00 - 17:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Zoom',
    type: 'upcoming',
    price: 60,
    thumbnailUrl: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 45,
    currentAttendees: 25,
    presenter: 'Dr. Amanda Chen',
    presenterImage: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'AI Research Scientist at DeepMind, PhD in Machine Learning',
    prerequisites: ['Machine Learning basics', 'Python programming', 'Linear Algebra'],
    materials: ['Deep Learning Frameworks', 'Model Architecture Guide', 'Research Papers'],
    recording: true,
    rating: 0,
    reviews: []
  },
  {
    id: 'WS-2025-017',
    title: 'Cybersecurity and Ethical Hacking',
    category: 'Cybersecurity',
    status: {
      label: 'Upcoming',
      badge: 'upcoming',
      actionButton: {
        label: 'Register',
        action: 'register'
      }
    },
    detailsButton: {
      label: 'View Details',
      action: 'viewDetails',
      modalContent: {
        title: true,
        instructor: true,
        category: true,
        price: true,
        description: true,
        datetime: true,
        duration: true
      }
    },
    description: 'Learn practical cybersecurity skills, penetration testing, and ethical hacking techniques. Master security auditing and vulnerability assessment.',
    date: '2025-05-27',
    time: '16:00 - 18:00',
    duration: '2 hours',
    location: 'Online',
    platform: 'Microsoft Teams',
    type: 'upcoming',
    price: 55,
    thumbnailUrl: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    maxAttendees: 40,
    currentAttendees: 28,
    presenter: 'Alex Rivera',
    presenterImage: 'https://images.unsplash.com/photo-1557862921-37829c790f19?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    presenterBio: 'Certified Ethical Hacker, Security Consultant for Fortune 500 companies',
    prerequisites: ['Networking basics', 'Command line proficiency'],
    materials: ['Security Tools Guide', 'Lab Environment Setup', 'Practice CTF Challenges'],
    recording: true,
    rating: 0,
    reviews: []
  }
];

const studentInternshipsData = {
  suggestedInternships,
  applicationStatus,
  upcomingDeadlines,
  workshops
};

export default studentInternshipsData;
